import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import t from 'react-translate';

// Components
import NvFormDropdown from 'shared/components/inputs/nv-form-dropdown';
import NvRadioButton from 'shared/components/inputs/nv-radio-button';

// Shared hook and styles
import {
  createLiveEventFilterStyles,
  useLiveEventFilter,
} from './use-live-event-filter';

const styles = createLiveEventFilterStyles('live-event-registration-trigger');

const FIELDS_TO_CLEAR = ['liveEventRegistrationTriggerEvent'];

const LiveEventRegistrationTrigger = () => {
  const { watch } = useFormContext();
  const [event] = watch(['event']);
  const isEnabled = event === 'live-event-registration';

  const { liveEventsList, noLiveEvents, buildDropdownOptions } = useLiveEventFilter(isEnabled, {
    fieldsToClear: FIELDS_TO_CLEAR,
    multiSessionOnly: false,
  });

  // Build live event dropdown options
  const liveEventOptions = useMemo(
    () => buildDropdownOptions(liveEventsList),
    [buildDropdownOptions, liveEventsList]
  );

  return (
    <div css={styles} className={`px-4 py-2 mb-4 live-event-registration-trigger ${isEnabled ? 'on' : ''}`}>
      <div className='inline-block mr-2 checkbox-wrapper'>
        <NvRadioButton
          withForm
          value='live-event-registration'
          name='event'
          label={t.COURSE_COMMUNICATIONS.FILTERS.LIVE_EVENT_SESSION.REGISTERED_TO_EVENT()}
          labelClassName='text-large-regular pl-6 mr-2'
        />
      </div>
      {noLiveEvents && (
        <div className='info text-small text-gray-2 font-weight-bold'>
          {t.COURSE_COMMUNICATIONS.FILTERS.LIVE_EVENT_SESSION.NO_MULTI_SESSION()}
        </div>
      )}
      <div className='dropdowns ml-6'>
        <NvFormDropdown
          name='liveEventRegistrationTriggerEvent'
          className='live-event'
          items={liveEventOptions}
          title={t.COURSE_COMMUNICATIONS.FILTERS.LIVE_EVENT_SESSION.SELECT_EVENT()}
        />
      </div>
    </div>
  );
};

export default LiveEventRegistrationTrigger;
